// @flow
import { type UserInputValidationError, VALID } from '@tectonics/prs/validation';

export function validateSafetypayOption(option: string): ?UserInputValidationError {
  if (!option || !option.trim())
    return { id: 'empty' };

  return VALID;
}
